import { Navigate, useSearchParams } from "react-router-dom"

import { Empty } from "@/atoms"
import { PAGE_NUMBER } from "@/helpers/filters.helper"
import { useTranslation } from "@/hooks/useTranslation"
import { SyncOutlined } from "@/icons"

import styles from "./EmptyTable.module.scss"

import type { ScanProgressEmptyTableProps } from "./EmptyTable.types"

export const ScanProgressEmptyTable = (props: ScanProgressEmptyTableProps) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const pageNumber = Number(searchParams.get(PAGE_NUMBER) || 0)

  if (pageNumber > 0 && props.isLoading === false) {
    // false - boolean value indicates should check page reset
    const nextParams = new URLSearchParams(searchParams)

    nextParams.delete(PAGE_NUMBER)

    return <Navigate to={`?${nextParams.toString()}`} replace />
  }

  return (
    <Empty
      image={<SyncOutlined spin className={styles.iconProgress} />}
      description={t("general.teasers.scanningProgress")}
    />
  )
}
